module.exports = __webpack_public_path__ + "img/cardpointe.bebe3a8d.png";